import React, { useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import ProductPageContext from './ProductPageContext';
import LandingPageContext from './LandingPageContext';
import NeuroRemoteSummaryPage from './RemoteSummaryPage';
import SurveyPageContext from './SurveyPageContext';
import TransitionContainer from './TransitionContainer';
import {useGuideConfig, usePages} from '../../hooks';
import {routerUrls} from '../../utils';
import {useDispatch} from '../../state/App/AppContext';
import {pageAnimationCompleted, PageAnimationStages} from '../../state/Navigation/NavigationActions';

const PageContainer = (props) => {
  const {
    className,
    LandingPage,
    SurveyPage,
    SummaryPage,
    DetailsPage,
    RemoteSummaryPage,
    transitionTimeout = 1250
  } = props;

  const dispatch = useDispatch();
  const { isRemoteSession } = useGuideConfig();
  const { currentPageUrl, isLoadingNextPage, isAnimatingPages } = usePages();
  const renderRedirect = location => currentPageUrl !== location.pathname ? <Redirect to={currentPageUrl} push /> : null;
  const componentClass = 'pageContainer';
  const classes = classnames(componentClass, className);
  const RemotePageComponent = RemoteSummaryPage || NeuroRemoteSummaryPage;

  useEffect(() => {
    if( isAnimatingPages === PageAnimationStages.RUNNING && transitionTimeout > 0 ) {
      setTimeout(() => {
        dispatch(pageAnimationCompleted());
      }, transitionTimeout + 250 );
    }
  }, [isAnimatingPages]);

  return (
    <Route
      render={({ location }) => (
        <div role="main" >
          <TransitionContainer
            className={classes}
            isLoadingNextPage={isLoadingNextPage}
            transitionKey={location.key}
            timeout={transitionTimeout}
          >
            <Switch location={location}>
              <Route exact path={routerUrls.landing}>
                <LandingPageContext Component={LandingPage} />
              </Route>
              <Route path={routerUrls.survey}>
                <SurveyPageContext Component={SurveyPage} />
              </Route>
              <Route path={routerUrls.summary}>
                <ProductPageContext Component={ isRemoteSession ? RemotePageComponent : SummaryPage } />
              </Route>
              <Route path={routerUrls.details}>
                <ProductPageContext Component={ isRemoteSession ? RemotePageComponent : DetailsPage } isDetails={ true } />
              </Route>
            </Switch>
          </TransitionContainer>
          {renderRedirect(location)}
        </div>
      )}
    />
  );
};

PageContainer.propTypes = {
  className: PropTypes.string,
  LandingPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  SurveyPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  SummaryPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  DetailsPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  RemoteSummaryPage: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  transitionTimeout: PropTypes.number
};

export default PageContainer;
